import React, { useEffect, useState } from "react";
import { object, array, string, number } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import CardImage from "../../atoms/CardImage";
import PollProgress from "../../atoms/pollProgress";
import NewsHeadline from "../../atoms/NewsHeadline";
import { DfpComponent } from "../../ads/dfp-component";
import DfpContainer from "../../ads/dfp-container";

import { getPollData } from "../../helper/api";
import { getBanglaDate, getSlotId, toBanglaNum } from "../../utils/utils";
import { staticTexts } from "../../utils/Translate";

import "./pollStory.m.css";

function PollStory({
  pollStory,
  pollTypeHostUrl,
  aspectRatio = [3, 2],
  imageType = "image3x2",
  widths = [250, 480, 764],
  index,
  domainSlug,
}) {
  const [pollData, setPollData] = useState(null);
  const polltypeId = get(pollStory, ["cards", 0, "story-elements", 0, "polltype-id"], null);

  useEffect(() => {
    getPollData(setPollData, pollTypeHostUrl, polltypeId);
  }, []);

  return (
    <>
      {pollData && (
        <>
          <div styleName="poll-story">
            <div styleName="date-option">
              <span>{pollData["published-at"] && getBanglaDate(pollData["published-at"])}</span>
            </div>
            <div styleName="story-details">
              <div styleName="story-details-headline">
                <NewsHeadline story={pollStory} linkEnable={false} />
              </div>
              {pollData["total-votes"] > 0 && (
                <div styleName="totalVote">
                  {staticTexts().voted} {toBanglaNum(pollData["total-votes"])} জন{" "}
                </div>
              )}
              {pollData.opinions &&
                pollData.opinions.map((item, index) => (
                  <PollProgress totalVotes={pollData["total-votes"]} item={item} key={index} />
                ))}
            </div>
            <div styleName="poll-story-image">
              <CardImage story={pollStory} aspectRatio={aspectRatio} imageType={imageType} widths={widths} />
            </div>
          </div>
          {index !== 0 && (index % 10 === 5 || index === 5) && (
            <DfpContainer>
              <div styleName="ad-wrapper" className="adsBox">
                <div styleName="ad-slot">
                  <DfpComponent
                    type="News_336x280_R2"
                    slotId={getSlotId("News_336x280_R2", "Stories2AdWithLoadMore", index)}
                  />
                </div>
              </div>
            </DfpContainer>
          )}
        </>
      )}
    </>
  );
}

PollStory.propTypes = {
  pollStory: object,
  pollTypeHostUrl: string,
  aspectRatio: array,
  imageType: string,
  widths: array,
  index: number,
  domainSlug: string,
};

const mapStateToProps = (state) => ({
  pollTypeHostUrl: get(state, ["qt", "config", "publisher-attributes", "pollTypeHostUrl"], null),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

export default connect(mapStateToProps)(PollStory);
